import { Rule } from '../types';

const MM_TO_IN = 25.4;
const CCQ_MAX_RUN_IN = 9000 / MM_TO_IN; // ~354.33"

export const ruleRunLength: Rule = (submission) => {
  if (submission.config.shape.kind !== 'straight') return null;
  const runIn = submission.config.shape.totalRunIn;
  if (runIn <= CCQ_MAX_RUN_IN) return null;
  const meters = (runIn * MM_TO_IN) / 1000;
  return {
    ruleId: 'run-too-long-no-landing',
    severity: 'warn',
    humanMessage: `La rampe est longue (${meters.toFixed(1)} m). On ajoute une plateforme de repos au milieu ?`,
    suggestion: {
      type: 'add-landing',
      patch: {}, // L'auto-fix concret est appliqué par computePlatforms — ici on signale juste
    },
  };
};
